import {
	EnhancedButtonPrimeReact,
	EnhancedButtonPrimeReactSeverity,
	EnhancedCheckboxRHF,
	EnhancedCheckboxRHFWithLabel,
	EnhancedDatePicker,
	EnhancedDropDownRHF,
	EnhancedDropDownRHFWithLabel,
	IEnhancedDropDownItem,
	LabelPosition,
	RHookFormDatePicker,
	RHookFormTextFieldWithLabel,
} from "@websential/cosmic-v20";
import { Navigate, useNavigate } from "react-router-dom";
import React, { useEffect, useState } from "react";

import { Grid } from "@mui/material";

interface IPayrollScheduleHeader {
	YearDDlItems?: IEnhancedDropDownItem[];
	taxYear: number;
	PayPeriodLabelsDDlItems?: IEnhancedDropDownItem[];
	onPayPeriodLabelChangeHandler: (selected: any) => void;
	payrollScheduleData: any;
	payrollFrequenciesDDL: any;
	onDeleteClicked: () => void;
	selectedPayPeriodId: (selected: any) => void;
	onYearyChangeHandler: (selected: any) => void;
	id: any,
	payrollSchedulePermissions: any
	formMethods: any;
	setEditRecordId: any;
	setPayrollScheduleData: (selected: any) => void;
}

export const PayrollScheduleHeader: React.FC<
	IPayrollScheduleHeader
> = ({ YearDDlItems, taxYear, PayPeriodLabelsDDlItems, onPayPeriodLabelChangeHandler, payrollScheduleData, payrollFrequenciesDDL,
	onDeleteClicked, selectedPayPeriodId, onYearyChangeHandler, formMethods, setEditRecordId, setPayrollScheduleData,
	id,
	payrollSchedulePermissions }) => {
		const navigate = useNavigate()
		const [payPeriod, setPayPeriod] = useState(undefined)
		const [payPeriodLabel, setPayPeriodLabel] = useState(undefined)
		const onPayPeriodChangeHandler = (event: any) => {
			setPayPeriod(event.value)
			selectedPayPeriodId(event.value)
			setPayPeriodLabel(event.label)
			formMethods.setValue("payPeriodLabelList", undefined);
			formMethods.setValue("payPeriodLabel", undefined);
			formMethods.setValue("firstPayPeriodEndDate", null);
			formMethods.setValue("setPaymentDate", 0);
			formMethods.setValue("showInPayroll", 200);
			formMethods.setValue("emailAlert", 200);
			setPayrollScheduleData(undefined);
			setEditRecordId(undefined);
			navigate("/company/payroll-schedule/");
		}

		useEffect(() => {
			if (payrollScheduleData && payrollScheduleData.payPeriod) {
				setPayPeriod(payrollScheduleData.payPeriod)
				selectedPayPeriodId(payrollScheduleData.payPeriodId)
				setPayPeriodLabel(payrollScheduleData.payPeriodLabel)
			}
		}, [payrollScheduleData])

		let selectedYear = YearDDlItems?.find((item: any) => item.label === taxYear)?.value

		return (
			<Grid
				container
				size={{ xs: 12, sm: 12, md: 12, lg: 12, xl: 12 }}
				columnSpacing={5}
				sx={{
					background: "#fff",
					border: "1px solid #e5e7eb",
					borderRadius: "2px 2px 0 0",
					// padding: "25px 5px 25px 17px",
					padding: "15px",
					mt: "12px"
				}}
			>
				<Grid
					size={{ xs: 12, sm: 6, md: 6, lg: 3.9, xl: 3.6 }}
				// sx={{ mt: "12px" }}
				>
					{YearDDlItems && <EnhancedDropDownRHFWithLabel
						selectName="year"
						testId={`year-list`}
						items={YearDDlItems ?? []}
						label={"Select Year"}
						selectedItem={YearDDlItems?.find((item: any) => item.value === taxYear)?.value}
						onSelectionChangeHandler={onYearyChangeHandler}
					/>}
					{payPeriod && <EnhancedDropDownRHFWithLabel
						selectName="payPeriodLabelList"
						testId={`payPeriodLabelList`}
						items={PayPeriodLabelsDDlItems ?? []}
						label={"Pay Period Label's List"}
						onSelectionChangeHandler={onPayPeriodLabelChangeHandler}
						selectedItem={'create-new'}
					/>}

					<RHookFormDatePicker
						name={"firstPayPeriodEndDate"}
						testId={"firstPayPeriodEndDate"}
						labelPosition={LabelPosition.Top}
						format="M dd, yy"
						label={"First Pay Period End Date"} />

					<EnhancedDropDownRHFWithLabel
						selectName="showInPayroll"
						testId={`showInPayroll`}
						items={[
							{ label: "Yes", value: 200 },
							{ label: "No", value: 100 }
						]}
						selectedItem={200}
						label={"Show in Payroll"}
					/>
					{payPeriodLabel && (payPeriodLabel === 'Monthly' || payPeriodLabel === 'Annually' || payPeriodLabel === 'Semimonthly') && (
						<EnhancedDropDownRHFWithLabel
							selectName="weakStart"
							testId={`weakStart`}
							items={[
								{ label: "Monday", value: "Monday" },
								{ label: "Tuesday", value: "Tuesday" },
								{ label: "Wednesday", value: "Wednesday" },
								{ label: "Thursday", value: "Thursday" },
								{ label: "Friday", value: "Friday" },
								{ label: "Saturday", value: "Saturday" },
								{ label: "Sunday", value: "Sunday" }
							]}
							selectedItem={"Monday"}
							label={"Week Start"}
						/>
					)}
				</Grid>
				<Grid
					size={{ xs: 12, sm: 6, md: 6, lg: 3.9, xl: 3.6 }}
				// sx={{ mt: "12px" }}
				>
					<EnhancedDropDownRHFWithLabel
						selectName="payPeriod"
						testId={`pay-period`}
						// items={[
						// 	{ label: "Annually", value: 1 },
						// 	{ label: "Monthly", value: 12 },
						// 	{ label: "Semi Monthly", value: 24 },
						// 	{ label: "Biweekly", value: 26 },
						// 	{ label: "Weekly", value: 52 },
						// ]}
						items={payrollFrequenciesDDL ?? []}
						label={"Pay Period"}
						onSelectionChangeHandler={onPayPeriodChangeHandler}
					/>
					{payPeriod && <RHookFormTextFieldWithLabel
						id={"payPeriodLabel"}
						testId={"payPeriodLabel"}
						label={"Pay Period Label"}
					/>}
					<EnhancedDropDownRHFWithLabel
						selectName="setPaymentDate"
						testId={`set-payment-date`}
						items={[
							{ label: "-20 Days", value: -20 },
							{ label: "-19 Days", value: -19 },
							{ label: "-18 Days", value: -18 },
							{ label: "-17 Days", value: -17 },
							{ label: "-16 Days", value: -16 },
							{ label: "-15 Days", value: -15 },
							{ label: "-14 Days", value: -14 },
							{ label: "-13 Days", value: -13 },
							{ label: "-12 Days", value: -12 },
							{ label: "-11 Days", value: -11 },
							{ label: "-10 Days", value: -10 },
							{ label: "-9 Days", value: -9 },
							{ label: "-8 Days", value: -8 },
							{ label: "-7 Days", value: -7 },
							{ label: "-6 Days", value: -6 },
							{ label: "-5 Days", value: -5 },
							{ label: "-4 Days", value: -4 },
							{ label: "-3 Days", value: -3 },
							{ label: "-2 Days", value: -2 },
							{ label: "-1 Days", value: -1 },
							{ label: "0 Days", value: 0 },
							{ label: "1 Days", value: 1 },
							{ label: "2 Days", value: 2 },
							{ label: "3 Days", value: 3 },
							{ label: "4 Days", value: 4 },
							{ label: "5 Days", value: 5 },
							{ label: "6 Days", value: 6 },
							{ label: "7 Days", value: 7 },
							{ label: "8 Days", value: 8 },
							{ label: "9 Days", value: 9 },
							{ label: "10 Days", value: 10 },
							{ label: "11 Days", value: 11 },
							{ label: "12 Days", value: 12 },
							{ label: "13 Days", value: 13 },
							{ label: "14 Days", value: 14 },
							{ label: "15 Days", value: 15 },
							{ label: "16 Days", value: 16 },
							{ label: "17 Days", value: 17 },
							{ label: "18 Days", value: 18 },
							{ label: "19 Days", value: 19 },
							{ label: "20 Days", value: 20 },
							{ label: "21 Days", value: 21 },
							{ label: "22 Days", value: 22 },
							{ label: "23 Days", value: 23 },
							{ label: "24 Days", value: 24 },
							{ label: "25 Days", value: 25 },
							{ label: "26 Days", value: 26 },
							{ label: "27 Days", value: 27 },
							{ label: "28 Days", value: 28 },
							{ label: "29 Days", value: 29 },
							{ label: "30 Days", value: 30 },
						]}
						selectedItem={0}
						label={"Set Payment Date"}
					/>

					<EnhancedDropDownRHFWithLabel
						selectName="emailAlert"
						testId={`emailAlert`}
						items={[
							{ label: "Yes", value: 200 },
							{ label: "No", value: 100 }
						]}
						selectedItem={200}
						label={"Email Alert"}
					/>
				</Grid>
				<Grid
					size={{ xs: 12, sm: 12, md: 12, lg: 4.2, xl: 4.8 }}
					sx={{
						// textAlign: "right",
						color: "rgba(0, 0, 0, 0.6)",
						fontSize: "0.875rem",
					}}
				>
					No. of Pay Periods for the year 12 <br />
					No. of Pay Periods used for tax calculation 12
					<br />
					{/* <EnhancedCheckboxRHF
					testId={"email-alert"} name={"emailAlert"} checked={false} checkboxLabel={"Email Alert"} /> */}
				</Grid>


				<Grid size={{ xs: 12, sm: 12, md: 12, lg: 12, xl: 12 }} sx={{ mt: "12px" }}>
					<EnhancedButtonPrimeReact
						label="Submit"
						raised
						type="submit"
						severity={EnhancedButtonPrimeReactSeverity.Success}
						disabled={payrollScheduleData && payrollScheduleData.scheduleAssignedToEmployee}
					/>
					<EnhancedButtonPrimeReact
						label="Delete"
						raised
						onClickHandler={onDeleteClicked}
						style={{ marginLeft: "1rem" }}
						severity={EnhancedButtonPrimeReactSeverity.Danger}
						disabled={
							!id ? true :
								payrollSchedulePermissions && payrollSchedulePermissions.totalWithSalaryProfile && payrollSchedulePermissions.totalWithSalaryProfile > 0 ? true :
									false
						}
					/>
				</Grid>
			</Grid>
		);
	};
